import { useState } from 'react';
import { fmtTons, regionColor } from '../utils';
import { ChartEmptyState } from './ChartEmptyState';

const R = 40;
const CIRCUMFERENCE = 2 * Math.PI * R;

export function DestinationMixChart({ data = [] }) {
  const [hover, setHover] = useState(null);
  if (!data.length) return <ChartEmptyState />;

  const total = data.reduce((s, d) => s + d.tons, 0) || 1;
  let cumulative = 0;
  const segments = data.map((d) => {
    const fraction = d.tons / total;
    const segmentLen = fraction * CIRCUMFERENCE;
    const offset = cumulative;
    cumulative += segmentLen;
    return {
      ...d,
      color: regionColor(d.region),
      segmentLen,
      offset,
      pct: Math.round(fraction * 100),
    };
  });

  return (
    <div className="flex items-center gap-5">
      <svg viewBox="0 0 100 100" width={140} height={140} className="flex-shrink-0 -rotate-90">
        {segments.map((s) => (
          <circle
            key={s.region}
            cx={50}
            cy={50}
            r={R}
            fill="none"
            stroke={s.color}
            strokeWidth={14}
            strokeDasharray={`${s.segmentLen} ${CIRCUMFERENCE - s.segmentLen}`}
            strokeDashoffset={-s.offset}
            opacity={hover != null && hover !== s.region ? 0.35 : 1}
            style={{ transition: 'opacity 150ms' }}
          />
        ))}
      </svg>
      <div className="flex-1 min-w-0 space-y-2.5">
        {segments.map((s) => (
          <div
            key={s.region}
            className="cursor-default"
            onMouseEnter={() => setHover(s.region)}
            onMouseLeave={() => setHover(null)}
          >
            <div className="flex items-center gap-2 text-[12px] text-slate-700">
              <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: s.color }} />
              <span className="truncate" title={s.region}>{s.region}</span>
            </div>
            <div className="flex items-center gap-1.5 pl-[18px] text-[11px] text-slate-500">
              <span className="font-semibold text-slate-800 tabular-nums">{fmtTons(s.tons)}</span>
              <span className="tabular-nums">· {s.pct}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DestinationMixChart;
